import $ from 'jquery';

const sidebarCart = () => {
	const init = () => {
		execute();
	};

	const execute = () => {
		const el = {
			menuCart: '.elementor-menu-cart__main',
			title: $('<div></div>').addClass('custom-cart-title'),
		};

		if ($(el.menuCart).length === 0) return;

		$(function () {
			// Set the title text
			el.title.text('Winkelwagen');

			// Insert the title at the top of the menu cart content
			$(el.menuCart).prepend(el.title);
		});
	};

	init();
};

try {
	sidebarCart();
} catch (error) {
	console.error('sidebarCart', error);
}
